/* eslint-disable */
import axios from "axios";

class OsmMapLoader {
  async loadOsmMap(tile, boundary) {
    let baseUrl =
      "https://overpass-api.de/api/interpreter?data=[out:json];\n(\n  node({s},{w},{n},{e});\n  way(bn);\n);\n(\n  ._;\n  node(w);\n);\nout;";

    let url = baseUrl.replace(/\{([swne])\}/g, (match, key) => {
      return boundary[key];
    });

    let rawData = await axios.get(encodeURI(url));
    //console.log(rawData);

    return this.createMapData(rawData);
  }

  createMapData(rawData) {
    let acc = {
      node: {},
      way: {},
      relation: {}
    };

    rawData.data.elements.forEach(elem => {
      return (acc[elem.type][elem.id] = elem);
    });

    let mapData = [];
    mapData["building"] = [];
    mapData["way"] = [];
    mapData["others"] = [];

    Object.keys(acc.way).forEach(index => {
      let item = acc.way[index];
      if (item.tags) {
        if (item.tags["highway"]) mapData["way"].push(item);
        else if (item.tags["railway"]) mapData["way"].push(item);
        else if (item.tags["building"]) mapData["building"].push(item);
        else if (item.tags["leisure"]) mapData["building"].push(item);
        else if (item.tags["amenity"]) mapData["building"].push(item);
        else if (item.tags["natural"]) mapData["building"].push(item);
        else if (item.tags["waterway"])
          if (item.tags["waterway"] === "river") mapData["way"].push(item);
          else mapData["building"].push(item);
        else if (item.tags["landuse"]) mapData["building"].push(item);
      }
    });

    Object.keys(acc.node).forEach(index => {
      let item = acc.node[index];
      if (item.tags) {
        if (item.tags["highway"]) mapData["others"].push(item);
        else if (item.tags["power"]) mapData["others"].push(item);
        else if (item.tags["amenity"]) mapData["others"].push(item);
      }
    });

    return { acc: acc, mapData: mapData };
  }
}
export default new OsmMapLoader();
